import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import channel from '../../assets/images/images.png';
import LoginModal from '../Login/LoginModal';
import SearchOverlay from '../SearchOverlay';
import HelpChat from '../HelpChat/HelpChat';
import FdicBanner from './FdicBanner';
import './Header.css';

const GROUPS = [
  {
    title: 'Checking & Savings',
    links: [
      { label: 'Checking', to: '/checking' },
      { label: 'Savings', to: '/saving' },
      { label: 'CDs', to: '/cd' },
    ],
  },
  {
    title: 'Business',
    links: [
      { label: 'Business Checking', to: '/BusinessChecking' },
      { label: 'Business Savings', to: '/Businesssavings' },
      { label: 'Business Loans', to: '/BusinessLoans' },
    ],
  },
  {
    title: 'Digital Banking',
    links: [
      { label: 'Online Banking', to: '/OnlineBanking' },
      { label: 'Mobile Banking', to: '/MobileBanking' },
      { label: 'Direct Deposit', to: '/DirectDeposit' },
      { label: 'Get the App', to: '/download' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Locations', to: '/location' },
      { label: 'Contact', to: '/contact' },
      { label: 'Loans', to: '/loans' },
      { label: 'Privacy', to: '/privacy' },
    ],
  },
];

const Mobiles = () => {
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <div className="mobile">
      <header className="gn-mobile-header">
        <FdicBanner />
        <div className="gn-mobile-bar">
          <button
            type="button"
            className="gn-mobile-menu-btn"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? '✕' : '☰'}
          </button>

          <Link to="/" className="gn-mobile-logo" onClick={closeMenu} aria-label="GN Bank home">
            <img src={channel} alt="" />
            <span className="gn-mobile-logo-text">GN Bank</span>
          </Link>

          <button
            type="button"
            className="btn btn-gn-primary"
            onClick={() => setShowModal(true)}
          >
            Log in
          </button>
        </div>

        <div className={`gn-mobile-panel${open ? ' is-open' : ''}`}>
          <Link to="/" className="gn-mobile-link" onClick={closeMenu}>
            Home
          </Link>

          {GROUPS.map((group) => (
            <div key={group.title}>
              <div className="gn-mobile-group-title">{group.title}</div>
              {group.links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="gn-mobile-sublink"
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          ))}

          <div className="gn-mobile-utility">
            <HelpChat label="Help" />
            <SearchOverlay label="Search" />
            <a
              className="gn-header__utility-link"
              href="https://portal.gnbank.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Customer portal
            </a>
          </div>
        </div>
      </header>

      <LoginModal show={showModal} handleClose={() => setShowModal(false)} />
      <div className="spacer" />
    </div>
  );
};

export default Mobiles;
